import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import {Anchor} from './splash-sections'

const CWM_SHOW = 'https://gnothiai.com/series/continue-without-me'
const CWM_EPISODE = 'https://gnothiai.com/series/continue-without-me/25b56bf4-c9c1-475b-bd9c-981ddd5a3a3c'
const CWM_AUDIO = 'https://files.gnothiai.com/7408962c-51d6-4877-b65f-d9dac376b2f5/audio/25b56bf4-c9c1-475b-bd9c-981ddd5a3a3c/published/af6adf4b-0c57-47b9-9891-95068390902f.mp3'
const CWM_COVER = 'https://files.gnothiai.com/7408962c-51d6-4877-b65f-d9dac376b2f5/podcasts/d688699d-8ddf-4b84-bdda-6d3ac3e97181/cover.png'

export default function FlagshipProof({compact = false}: {compact?: boolean}) {
  return <Anchor id="flagship">
    <Grid container spacing={compact ? 2 : 3} sx={{alignItems: 'center'}}>
      <Grid size={{xs: 12, md: compact ? 4 : 5}}><Box component="img" src={CWM_COVER} alt="Continue Without Me cover" loading={compact ? undefined : 'lazy'} sx={{display: 'block', width: '100%', maxWidth: compact ? 240 : 360, mx: 'auto', borderRadius: 3}} /></Grid>
      <Grid size={{xs: 12, md: compact ? 8 : 7}}>
        <Stack spacing={1.25}>
          <Typography variant="overline" component="p" sx={{color: 'splash.accent', fontWeight: 800}}>A real Gnothi Series</Typography>
          <Typography variant={compact ? 'h4' : 'h3'} component="h2">Continue Without Me</Typography>
          <Typography color="text.secondary">A cyberpunk thriller about a founder and the AI agent he hires. Business, AI, and questions about freedom run through the story.</Typography>
          <Typography variant="body2" color="text.secondary">Hear a roughly 30-minute chapter from <em>Continue Without Me</em>.</Typography>
          {/* The public episode page, RSS metadata and MP3 support the approximate runtime. The source accepts byte ranges and serves audio/mpeg. */}
          <Box component="audio" controls preload="metadata" src={CWM_AUDIO} sx={{width: '100%'}} aria-label="Play The Deposit from Continue Without Me" />
          <Stack direction="row" spacing={1} useFlexGap sx={{flexWrap: 'wrap'}}>
            <Button component="a" href={CWM_EPISODE} variant="contained">Hear the full chapter</Button>
            <Button component="a" href={CWM_SHOW} variant="outlined">Explore the Series</Button>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  </Anchor>
}
